<template>
  <div v-if="showBreadcrumbs" class="content-breadcrumbs elevation-1">
    <h1 class="pt-1">{{ getTitle }}</h1>
    <div class="d-flex">
      <v-breadcrumbs :items="getBreadcrumbs" :divider="breadcrumbs.divider" class="breadcrumbs"></v-breadcrumbs>
      <i4proChangeFontSize v-if="breadcrumbs.accessibility" />
    </div>
  </div>
</template>

<script>
import store from '@/store';

export default {
  components: {
    i4proChangeFontSize: () => import('@/components/accessibility/i4pro-accessibility-font')
  },

  computed: {
    getTitle() {
      const namePage = store.getters['menu/currentPage'];

      if (!namePage) return '';

      document.title = store.getters['page/title'](namePage);

      return store.getters['page/title'](namePage);
    },

    getBreadcrumbs: () => store.getters['breadcrumbs/getBreadcrumbs'] || [],

    breadcrumbs: () => store.getters['layout/getBreadcrumbs'],

    showBreadcrumbs() {
      const namePage = store.getters['menu/currentPage'];
      const breadcrumbs = store.getters['page/showBreadcrumbs'](namePage);

      if (breadcrumbs == undefined || breadcrumbs == null) {
        return true;
      }

      return breadcrumbs;
    }
  }
};
</script>
